import { useEffect, useState } from "react";

const useScreenHeight = () => {
  const [data, setData] = useState(window.innerHeight);

  useEffect(() => {
    let resizeTimeout: any;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        setData(window.innerHeight);
      }, 200);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return data;
};

export default useScreenHeight;
